import { useContext, useEffect, useRef, useState } from 'react';
import { CSSTransition } from 'react-transition-group';

import { CustomerReportContext } from 'components/grace/Contexts';
import useScreenSizeConstants from 'hooks/useScreenSizeConstants';

import ModalSwitcher from './ModalSwitcher';
import NavigationHeader from './NavigationHeader';
import SurveyModalContent from './SurveyModalContent';

const SurveyModal = () => {
  const { closeSurvey } = useContext(CustomerReportContext);
  const { isMobile } = useScreenSizeConstants();
  const ref = useRef(null);

  const [isSurveyOpen, setIsSurveyOpen] = useState(false);
  const [userHasRated, setUserHasRated] = useState(false);

  useEffect(() => {
    if (userHasRated) {
      setTimeout(() => {
        onDismiss();
      }, 1500);
    } else {
      setIsSurveyOpen(true);
    }
  }, [userHasRated]);

  const handleRatingClick = () => {
    setUserHasRated(true);
  };

  const onDismiss = () => {
    setIsSurveyOpen(false);
    closeSurvey();
  };

  const renderNavigation = () => {
    return (
      <>
        <NavigationHeader onDismiss={() => onDismiss()} />
      </>
    );
  };

  return (
    <>
      <ModalSwitcher
        showIcon={false}
        title="Survey"
        onDismiss={() => onDismiss()}
        bodyPadding="p-0"
        bodyStyle={isMobile ? 'pb-10 bp1:pb-2' : 'pb-6'}
        topBarStyle="hidden"
        explicitBodyStyle={true}
        explicitTopBarStyle={true}
        mainContentClass="show pointer-events-auto fixed bottom-0 right-0 left-0 bp1:bottom-4 bp1:right-4 bp1:left-auto bp1:width-sm bp2:w-[390px] ml-auto bg-white-100 rounded-t-lg bp1:rounded-lg border border-solid border-charcoal-50 shadow-xl"
        containerStyle="bottom-0 top-auto right-0 left-0 p-0 max-h-fit"
        renderModalInCenter={false}
        contentClassname={'ml-auto rounded-t-lg border border-solid border-charcoal-50'}
        explicitMainContentClass={true}
        transitionRef={ref}
        useMinHeight={Boolean(true)}
        navigationHeader={renderNavigation()}
        childrenContainerClassnames={
          isMobile ? 'w-full bp1:max-w-sm' : 'h-full max-h-[562px] max-w-sm overflow-y-auto'
        }
      >
        <CSSTransition
          in={Boolean(isSurveyOpen)}
          timeout={500}
          classNames="slideout-from-bottom"
          nodeRef={ref}
        >
          <SurveyModalContent onRatingClick={() => handleRatingClick()} />
        </CSSTransition>
      </ModalSwitcher>
    </>
  );
};

export default SurveyModal;
